import brandShortName from './collaborators/brand-short-name';
import channel from './collaborators/channel';
import pageName from './collaborators/page-name';
import pageType from './collaborators/page-type';
import brIUID from './collaborators/br-iuid';
import relatedRID from './collaborators/related-rid';

export default props => {
  const { categoryName, businessUnitId, subcategoryName } = props;

  const attributes = {
    brand_short_name: brandShortName(props),
    browse_refine_type: [],
    browse_refine_value: [],
    business_unit_id: businessUnitId,
    category_name: categoryName,
    channel: channel(props),
    page_name: pageName(props),
    page_type: pageType(props),
    br_iuid: brIUID(props),
    br_related_rid: relatedRID(props),
  };

  if (subcategoryName) {
    attributes.subcategory_name = subcategoryName;
  }

  return attributes;
};
